import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { BehaviorSubject, interval, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PromptPwaUpdateService {
  private showUpdateModal = new BehaviorSubject<boolean>(false);
  showUpdateModal$ = this.showUpdateModal.asObservable();

  private readonly CHECK_INTERVAL = 30 * 1000;

  constructor(private swUpdate: SwUpdate) {
    if (this.swUpdate.isEnabled) {
      console.log('Checking if promptPwaUpdateService is enabled');
      this.swUpdate.versionUpdates.subscribe(evt => {
        if (evt.type === 'VERSION_READY') {
          this.showUpdateModal.next(true);
        }
      });

      this.startPeriodicChecks();
    }
  }

  forceAppUpdate(): void {
    this.swUpdate.activateUpdate().then(() => document.location.reload());
  }

  private startPeriodicChecks(): void {
    interval(this.CHECK_INTERVAL)
      .pipe(switchMap(() => this.swUpdate.checkForUpdate()))
      .subscribe();
  }
}
